import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage";
import { ALL_THEME_CLASSES, getTheme } from "../theme/themes";

// ColorMode is an open string (theme id). Valid ids live in theme/themes.ts.
export type ColorMode = string;

export function isDarkBackground(mode: ColorMode): boolean {
  return getTheme(mode).isDark;
}

/** Apply a theme's body classes imperatively (idempotent). */
export function applyThemeClasses(mode: ColorMode) {
  const body = window.document.body.classList;
  body.remove(...ALL_THEME_CLASSES);
  for (const cls of getTheme(mode).classes) body.add(cls);
}

// Kept structurally identical to the original (which worked): useLocalStorage
// holds the state and persists via JSON, an effect applies the body classes.
// The only change vs original is data-driven theme classes (registry) instead
// of a hardcoded if/else — so any number of palettes work.
export default function useColorMode() {
  const [colorMode, setColorMode] = useLocalStorage<ColorMode>("color-theme", "dark");

  useEffect(() => {
    applyThemeClasses(colorMode);
  }, [colorMode]);

  return [colorMode, setColorMode] as const;
}
